<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuth } from '../plugin';

const { loginCallback } = useAuth();

const router = useRouter();
onMounted(() => {
  setTimeout(() => {
    loginCallback()
      .then(() => {
        router.replace('/');
      })
      .catch((error) => {
        router.replace(`/error?message=${error.message || error}`);
      });
  }, 500);
});
</script>

<template>
  <n-card
    mx-auto
    my-4
    max-w-500px
  >
    <div text-center>
      <n-spin size="small" />
    </div>
    <div
      mt-3
      text-center
    >
      Connecting...
    </div>
  </n-card>
</template>
